import { Box, TextField } from '@mui/material'
import { FC, useEffect, useState, useContext } from 'react'
import { useDebounce } from 'use-debounce'

import AccountFilter from './AccountFilter'
import EntryTypeFilter from './EntryTypeFilter'
import { JournalEntriesContext } from '../../../../context/JournalEntriesContext'
import DateRangeFilter from '../../../common/DateRangeFilter'

const JournalEntriesFilters: FC = () => {
  const { filters, setFilters } = useContext(JournalEntriesContext)
  const [searchTerm, setSearchTerm] = useState<string>('')

  const [debouncedSearchTerm] = useDebounce(searchTerm, 500)

  const handleStartDateChange = (date: string) => {
    setFilters({ startDate: date || undefined })
  }

  const handleEndDateChange = (date: string) => {
    setFilters({ endDate: date || undefined })
  }

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value)
  }

  useEffect(() => {
    setFilters({ searchTerm: debouncedSearchTerm })
  }, [debouncedSearchTerm, setFilters])

  return (
    <Box display="flex" gap={2} alignItems="center" flexWrap="wrap" sx={{ px: 2, pt: 3, pb: 4 }}>
      <EntryTypeFilter />
      <AccountFilter />

      <DateRangeFilter
        fromDate={filters.startDate || null}
        toDate={filters.endDate || null}
        onFromDateChange={handleStartDateChange}
        onToDateChange={handleEndDateChange}
        size="medium"
      />

      <TextField
        label="Search"
        placeholder="Search by bill # or case # or ref no or notes"
        value={searchTerm}
        sx={{ minWidth: 350, ml: 'auto' }}
        onChange={handleSearchChange}
      />
    </Box>
  )
}

export default JournalEntriesFilters
